module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"copied":"O link da seleção foi copiado para a área de transferência.","no-selection-description":"Você ainda não criou nenhuma seleção.","no-selection-title":"Não há seleções"}}')
  delete Component.options._Ctor
}
